import { createFileRoute, redirect } from '@tanstack/react-router';
import { readAuthToken } from '@noor/api';
import { env } from '@noor/config';
import { CourierOffersPage } from '@/pages/courier-offers';

export const Route = createFileRoute('/couriers/offers')({
  staticData: { permission: 'couriers.view' },
  beforeLoad: () => {
    if (!env.VITE_ENABLE_MSW && !readAuthToken()) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/login' });
    }
  },
  component: CourierOffersPage,
});
